import responsavelSchema from "../../schema/responsavel-schema";

const inviteEmpresaSchema = responsavelSchema.pick(["nome", "email"]);

export default inviteEmpresaSchema;
